/**
 * Timezone Options for dropdown selection
 * Uses IANA timezone identifiers
 */

export const TIMEZONE_OPTIONS = [
  // India & South Asia
  { value: 'Asia/Kolkata', label: 'India (IST)', offset: 'UTC+5:30' },
  { value: 'Asia/Colombo', label: 'Sri Lanka', offset: 'UTC+5:30' },
  { value: 'Asia/Kathmandu', label: 'Nepal', offset: 'UTC+5:45' },
  { value: 'Asia/Dhaka', label: 'Bangladesh', offset: 'UTC+6' },
  { value: 'Asia/Karachi', label: 'Pakistan', offset: 'UTC+5' },

  // Middle East
  { value: 'Asia/Dubai', label: 'UAE (Dubai)', offset: 'UTC+4' },
  { value: 'Asia/Riyadh', label: 'Saudi Arabia', offset: 'UTC+3' },
  { value: 'Asia/Kuwait', label: 'Kuwait', offset: 'UTC+3' },
  { value: 'Asia/Qatar', label: 'Qatar', offset: 'UTC+3' },
  { value: 'Asia/Bahrain', label: 'Bahrain', offset: 'UTC+3' },
  { value: 'Asia/Muscat', label: 'Oman', offset: 'UTC+4' },

  // Southeast Asia
  { value: 'Asia/Singapore', label: 'Singapore', offset: 'UTC+8' },
  { value: 'Asia/Kuala_Lumpur', label: 'Malaysia', offset: 'UTC+8' },
  { value: 'Asia/Bangkok', label: 'Thailand', offset: 'UTC+7' },
  { value: 'Asia/Jakarta', label: 'Indonesia (WIB)', offset: 'UTC+7' },
  { value: 'Asia/Manila', label: 'Philippines', offset: 'UTC+8' },
  { value: 'Asia/Ho_Chi_Minh', label: 'Vietnam', offset: 'UTC+7' },

  // East Asia
  { value: 'Asia/Hong_Kong', label: 'Hong Kong', offset: 'UTC+8' },
  { value: 'Asia/Shanghai', label: 'China', offset: 'UTC+8' },
  { value: 'Asia/Tokyo', label: 'Japan', offset: 'UTC+9' },
  { value: 'Asia/Seoul', label: 'South Korea', offset: 'UTC+9' },
  { value: 'Asia/Taipei', label: 'Taiwan', offset: 'UTC+8' },

  // Europe
  { value: 'Europe/London', label: 'UK (London)', offset: 'UTC+0/+1' },
  { value: 'Europe/Paris', label: 'France', offset: 'UTC+1/+2' },
  { value: 'Europe/Berlin', label: 'Germany', offset: 'UTC+1/+2' },
  { value: 'Europe/Amsterdam', label: 'Netherlands', offset: 'UTC+1/+2' },
  { value: 'Europe/Rome', label: 'Italy', offset: 'UTC+1/+2' },
  { value: 'Europe/Madrid', label: 'Spain', offset: 'UTC+1/+2' },
  { value: 'Europe/Zurich', label: 'Switzerland', offset: 'UTC+1/+2' },
  { value: 'Europe/Moscow', label: 'Russia (Moscow)', offset: 'UTC+3' },

  // Americas
  { value: 'America/New_York', label: 'US Eastern', offset: 'UTC-5/-4' },
  { value: 'America/Chicago', label: 'US Central', offset: 'UTC-6/-5' },
  { value: 'America/Denver', label: 'US Mountain', offset: 'UTC-7/-6' },
  { value: 'America/Los_Angeles', label: 'US Pacific', offset: 'UTC-8/-7' },
  { value: 'America/Toronto', label: 'Canada (Toronto)', offset: 'UTC-5/-4' },
  { value: 'America/Vancouver', label: 'Canada (Vancouver)', offset: 'UTC-8/-7' },
  { value: 'America/Sao_Paulo', label: 'Brazil', offset: 'UTC-3' },
  { value: 'America/Mexico_City', label: 'Mexico', offset: 'UTC-6/-5' },

  // Australia & Pacific
  { value: 'Australia/Sydney', label: 'Australia (Sydney)', offset: 'UTC+10/+11' },
  { value: 'Australia/Melbourne', label: 'Australia (Melbourne)', offset: 'UTC+10/+11' },
  { value: 'Australia/Perth', label: 'Australia (Perth)', offset: 'UTC+8' },
  { value: 'Pacific/Auckland', label: 'New Zealand', offset: 'UTC+12/+13' },

  // Africa
  { value: 'Africa/Johannesburg', label: 'South Africa', offset: 'UTC+2' },
  { value: 'Africa/Cairo', label: 'Egypt', offset: 'UTC+2' },
  { value: 'Africa/Lagos', label: 'Nigeria', offset: 'UTC+1' },
  { value: 'Africa/Nairobi', label: 'Kenya', offset: 'UTC+3' },

  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)', offset: 'UTC+0' },
];

// Get timezone by value
export const getTimezoneByValue = (value) => {
  return TIMEZONE_OPTIONS.find(tz => tz.value === value) || TIMEZONE_OPTIONS[0];
};

// Get formatted label with offset
export const getTimezoneLabel = (value) => {
  const tz = getTimezoneByValue(value);
  return `${tz.label} (${tz.offset})`;
};

export default TIMEZONE_OPTIONS;
